module.exports = __webpack_public_path__ + "img/tc.fd312604.svg";